export const PER_PAGE_PROPERTY_DETAIL_NO_AUTH = 'PER_PAGE_PROPERTY_DETAIL_NO_AUTH'
export const PAGE_PROPERTY_DETAIL_NO_AUTH = 'PAGE_PROPERTY_DETAIL_NO_AUTH'
export const PAGES_PROPERTY_DETAIL_NO_AUTH = 'PAGES_PROPERTY_DETAIL_NO_AUTH'
export const IS_LOADING_TABLE_PROPERTY_DETAIL_NO_AUTH = 'IS_LOADING_TABLE_PROPERTY_DETAIL_NO_AUTH'
export const ARRAY_LIST_ALBUMS_TYPES_PROPERTY_DETAIL_NO_AUTH = 'ARRAY_LIST_ALBUMS_TYPES_PROPERTY_DETAIL_NO_AUTH'
export const ARRAY_LIST_ALBUMS_TYPES_FILES_PROPERTY_DETAIL_NO_AUTH = 'ARRAY_LIST_ALBUMS_TYPES_FILES_PROPERTY_DETAIL_NO_AUTH'
export const FORM_DATA_PROPERTY_DETAIL_NO_AUTH = 'FORM_DATA_PROPERTY_DETAIL_NO_AUTH'
